import { extendSchema, buildASTSchema } from 'graphql';
import { parseGraphQLSDL, isDocumentNode } from '@graphql-tools/utils';
import { filterAndExtractExtensionDefinitions } from './extensionDefinitions';
import { concatenateTypeDefs } from './concatenateTypeDefs';
export function buildSchemaFromTypeDefinitions(typeDefinitions, parseOptions, noExtensionExtraction) {
    var document = buildDocumentFromTypeDefinitions(typeDefinitions, parseOptions);
    if (noExtensionExtraction) {
        return buildASTSchema(document);
    }
    var _a = filterAndExtractExtensionDefinitions(document), typesAst = _a.typesAst, extensionsAst = _a.extensionsAst;
    var backcompatOptions = { commentDescriptions: true };
    var schema = buildASTSchema(typesAst, backcompatOptions);
    if (extensionsAst.definitions.length > 0) {
        schema = extendSchema(schema, extensionsAst, backcompatOptions);
    }
    return schema;
}
export function buildDocumentFromTypeDefinitions(typeDefinitions, parseOptions) {
    var document;
    if (typeof typeDefinitions === 'string') {
        document = parseGraphQLSDL('', typeDefinitions, parseOptions).document;
    }
    else if (Array.isArray(typeDefinitions)) {
        document = parseGraphQLSDL('', concatenateTypeDefs(typeDefinitions), parseOptions).document;
    }
    else if (isDocumentNode(typeDefinitions)) {
        document = typeDefinitions;
    }
    else {
        var type = typeof typeDefinitions;
        throw new Error("typeDefs must be a string, array or schema AST, got " + type);
    }
    return document;
}
//# sourceMappingURL=buildSchemaFromTypeDefinitions.js.map